import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12 5.625c.207 0 .375.168.375.375v5.625H18a.375.375 0 0 1 0 .75h-5.625V18a.375.375 0 0 1-.75 0v-5.625H6a.375.375 0 0 1 0-.75h5.625V6c0-.207.168-.375.375-.375",
		clipRule: "evenodd"
	})
});
export default SvgPlus;
